import { z } from 'zod';

import { translations } from '@/locale';
import { MAX_FILE_SIZE_IN_MB, STRING_LONG_MAX_LENGTH } from '@/constants';

export const emailSchema = z
  .string()
  .email('Invalid email address')
  .max(STRING_LONG_MAX_LENGTH, `Email must be at most ${STRING_LONG_MAX_LENGTH} characters`);

export const phoneNumberSchema = z.string().regex(/^[0-9 +()-]+$/, translations.validation.custom.phoneNumber);

export const imageSchema = z
  .object({
    url: z.string().optional(),
    thumbnailUrl: z.string().optional(),
    file: z.instanceof(File).optional()
  })
  .refine(
    (value) => {
      if (!value.file) return true;
      return value.file.size <= MAX_FILE_SIZE_IN_MB * 1024 * 1024;
    },
    {
      message: translations.validation.custom.fileSizeExceeded,
      params: { size: MAX_FILE_SIZE_IN_MB }
    }
  );

export const timeSchema = z.string().regex(/^[0-9]{2}:[0-9]{2}$/, translations.validation.custom.time);
